const featureFlagsDictionary = {
  COB_1796: "COB-1796_iFeel",
  BI_6: "BI-6_new-meal-benefit-experience",
  BI_264: "BI-264_benefit-new-experience",
  BT_10: "BT-10_employee-group-movements",
  BT_997: "BT-997_benefit-requests",
  ET_337: "ET-337_should_consider_only_ledger_transactions",
  EG_398: "EG-398_should_show_gym_benefit",
  BI_1434: "BI-1434_new_look_and_feel_for_bags",
  BI_2174: "BI-2174_benefit-request-detail-page-migrated",
  BI_2458: "BI-2458_show_custom_benefits_card",
  BI_2406: "BI-2406_catalogue-show-request-experience",
  ENT_259: "ENT-259_renting-revamp",
  SMES_2112: "SMES-2112-employee-groups-managment",
  BI_3777: "BI-3777_education_benefit_requests",
  SMES_2223: "SMES-2223_show-boe-packages-section",
  BA_134: "BA-134_pension_plan_new_experience",
  BI_7735: "BI-7735_show_analytics_in_sidebar_to_everyone",
};

export default featureFlagsDictionary;
